<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ insightVector.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : insightVector.length }} of {{ insightVector.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <!-- <datepicker class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="날짜" :language="$vs.rtl ? langHe : langEn" v-model="selectDate" :highlighted="highlightedFn"/> -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <!-- <vs-dropdown vs-trigger-click class="cursor-pointer"> -->
        <div v-if="activeUserLevel >= 3" class="p-3 rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-35">
          <vue-excel-xlsx :data="excelData" :columns="excelColumns" :filename="excelFileName" :sheetname="'sheet'">
            <vs-button  icon-pack="feather" icon="icon-download" type="flat" style="margin-left:8px; margin-right:8px; margin-bottom:5px;" color="dark" size="small">Export</vs-button>
          </vue-excel-xlsx>
        </div>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="insightVector"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage"/>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

import InsightLink from "./cell-renderer/InsightLink.vue"
import InsightStatus from "./cell-renderer/InsightStatus.vue"
import InsightTotalAttend from "./cell-renderer/InsightTotalAttend.vue"
import InsightActions from   "./cell-renderer/InsightActions.vue"
import InsightTestScore from "./cell-renderer/InsightTestScore.vue"
import InsightSubmitScore from "./cell-renderer/InsightSubmitScore.vue"
import JsonExcel from 'vue-json-excel'



export default {
  name: 'InsightUser',
  components: {
    AgGridVue,
    vSelect,
    InsightLink,
    InsightStatus,
    InsightTotalAttend,
    InsightActions,
    InsightTestScore,
    InsightSubmitScore,
    // ExprotExcel,
    'download-excel': JsonExcel
  },
  data() {
    return {
      excelFileName:'',
      excelColumns:[],
      excelData:[],
      selectDate: new Date(),
      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
      },

      columnDefs: [
        {
          headerName: '이름',
          field: 'name',
          width: 101,
          cellRendererFramework: 'InsightLink'
        },
        {
          headerName: '출결',
          field: 'attend',
          width: 200,
          cellRendererFramework: 'InsightTotalAttend'
        },
      ],
      components: {
        InsightLink,
        InsightStatus,
        InsightTotalAttend,
        InsightActions,
        InsightTestScore,
        InsightSubmitScore,
      },
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    activeWorkspace() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    workspaceMembers() {
      return this.$store.state.space.workspaceMembers
    },
    reports(){
      return this.$store.state.insight.reports
    },
    testResults(){
      return this.$store.state.insight.testResults
    },
    insightVector(){
      return this.$store.state.insight.insightVector
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    scoreFormat(value){
      return value.score
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
  },
  beforeDestroy() {
    // this.$store.unregisterModule('insight')
    // moduleInsight.isRegistered = false
  },
  created() {
    this.excelColumns = [{label:'이름', field:'name'},{label:'출석', field:'attend_count'}, {label:'지각', field:'late_count'}, {label:'결석', field:'miss_count'}]
    this.excelFileName = '[필드유] '+this.activeWorkspace.title +'_종합_'+ this.$moment(new Date).format('MM-DD')
    if(!this.reports){
      this.$store.dispatch("insight/getReport", this.activeWorkspace.id).then(()=>{
        for(var i in this.reports){
          this.columnDefs.push({headerName: '과제'+ (Number(i)+1), field: 'report'+i, width: 101, cellRendererFramework: 'InsightSubmitScore'})
          this.excelColumns.push({label:this.reports[i].submit.title, field:'report'+i, dataFormat: this.scoreFormat})
          for (var j in this.insightVector){
            var user = this.insightVector[j]
            var member= this.reports[i].submit_members.find((member) => member.user_id == user.user_id)
            var obj = {}
            if(member){
              obj = {index:j, submit_id:this.reports[i].submit.id, submit_member_id:member.id, fildName:'report'+i, score:member.score, submit_title:this.reports[i].submit.title}
            }
            else{
              obj = {index:j, submit_id:this.reports[i].submit.id, submit_member_id:0, fildName:'report'+i, score:'미제출', submit_title:this.reports[i].submit.title}
            }
            this.$store.commit("insight/UPDATE_SUBMIT_INSIGHT_VECTOR", obj)
          }
        }
      })
    }
    else{
      for(var i in this.reports){
        this.columnDefs.push({headerName: '과제'+(Number(i)+1), field: 'report'+i, width: 101, cellRendererFramework: 'InsightSubmitScore'})
        this.excelColumns.push({label:this.reports[i].submit.title, field:'report'+i, dataFormat: this.scoreFormat})
      }
    }
    if(!this.testResults){
      this.$store.dispatch("insight/getTestResult", this.activeWorkspace.id).then(()=>{
        for(var i in this.testResults){
          this.columnDefs.push({headerName: '시험'+(Number(i)+1), field: 'test'+i, width: 101, cellRendererFramework: 'InsightTestScore'})
          this.excelColumns.push({label:this.testResults[i].online_test.title, field:'score'+i, dataFormat: this.scoreFormat})
          for (var j in this.insightVector){
            var user = this.insightVector[j]
            var member= this.testResults[i].online_test_members.find((member) => member.user_id == user.user_id)
            var obj = {}
            if(member){
              obj = {index:j, test_id:this.testResults[i].online_test.id, test_member_id:member.id,fildName:'test'+i,score: member.score, test_title:this.testResults[i].online_test.title}
            }
            else{
              obj = {index:j, test_id:this.testResults[i].online_test.id, test_member_id:0, fildName:'test'+i, score:'미제출', test_title:this.testResults[i].online_test.title}
            }
            this.$store.commit("insight/UPDATE_TEST_INSIGHT_VECTOR", obj)
          }
        }
      })
    }
    else{
      for(var j in this.testResults){
        this.columnDefs.push({headerName: '시험'+( Number(j)+1), field: 'test'+j, width: 101, cellRendererFramework: 'InsightTestScore'})
        this.excelColumns.push({label:this.testResults[j].online_test.title, field:'test'+j, dataFormat: this.scoreFormat})
      }
    }
    this.excelData = this.insightVector
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
